import { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';

import ModalScreen from 'component/ModalScreen';

const LocationReportTable = ({data, total, ...props}) => {

  let [modal,   setModal  ] = useState(null);
  let [sortBy,  setSortBy ] = useState('');
  let [sortDir, setSortDir] = useState(1);

  useEffect(() => {

    switch (sortBy)
    {
      case '':
      case 'loc_key':
        data.sort((a, b) => {
          if (a.srv_dis > b.srv_dis) return  sortDir;
          if (a.srv_dis < b.srv_dis) return -sortDir;
          if (a.srv_loc > b.srv_loc) return  sortDir;
          if (a.srv_loc < b.srv_loc) return -sortDir;
          return 0;
        });
        break;
      default:
        data.sort((a, b) => {
          if (a[sortBy] > b[sortBy]) return  sortDir;
          if (a[sortBy] < b[sortBy]) return -sortDir;
          return 0;
        });
    }
  }, [sortBy, sortDir]);

  const toggleSortBy = (by) =>
  {
    if (sortBy == by)
    {
      if (-1 == sortDir)
        setSortBy('');
      else
        setSortDir(-1);
      return;
    }
    setSortBy(by);
    setSortDir(1);
  }

  const showDetail = (d) => {
    setModal(
      <div className="split-5">
        <div>
          <strong>車隊新</strong>
          <div>{ d.lic_newFleet.map(lic => <div key={lic} className="tag license">{lic}</div> )}</div>
        </div>
        <div>
          <strong>其他新</strong>
          <div>{ d.lic_newOther.map(lic => <div key={lic} className="tag license">{lic}</div> )}</div>
        </div>
        <div>
          <strong>重開</strong>
          <div>{ d.lic_reunion.map(lic => <div key={lic} className="tag license">{lic}</div> )}</div>
        </div>
        <div>
          <strong>終止</strong>
          <div>{ d.lic_normTerm.map(lic => <div key={lic} className="tag license">{lic}</div> )}</div>
        </div>
        <div>
          <strong>公司停</strong>
          <div>{ d.lic_compTerm.map(lic => <div key={lic} className="tag license">{lic}</div> )}</div>
        </div>
      </div>
    );
  }

  return (<>
    <table className="data-table full-width rpt-loc-table">
      <colgroup>
        <col width="36px"  id="col-locrpt-btn" />
        <col width="50px"  id="col-locrpt-loc" />
        <col width="auto"  id="col-locrpt-loc-name" />
        <col width="120px" id="col-locrpt-active" />
        <col width="120px" id="col-locrpt-new-all" />
        <col width="120px" id="col-locrpt-new-fleet" />
        <col width="120px" id="col-locrpt-new-other" />
        <col width="120px" id="col-locrpt-reu" />
        <col width="120px" id="col-locrpt-term-norm" />
        <col width="120px" id="col-locrpt-term-comp" />
      </colgroup>
      <thead>
        <tr>
          <th className="col-locrpt-btn"       ></th>
          <th className="col-locrpt-loc"       onClick={e=>toggleSortBy('loc_key')}     >#</th>
          <th className="col-locrpt-loc-name"  onClick={e=>toggleSortBy('loc_name')}    >屋苑</th>
          <th className="col-locrpt-active"    onClick={e=>toggleSortBy('cnt_total')}   >總數</th>
          <th className="col-locrpt-new-all"   onClick={e=>toggleSortBy('cnt_new')}     >新車</th>
          <th className="col-locrpt-new-fleet" onClick={e=>toggleSortBy('cnt_newFleet')}>新車(車隊)</th>
          <th className="col-locrpt-new-other" onClick={e=>toggleSortBy('cnt_newOther')}>新車(其他)</th>
          <th className="col-locrpt-reu"       onClick={e=>toggleSortBy('cnt_reunion')} >重開</th>
          <th className="col-locrpt-term"      onClick={e=>toggleSortBy('cnt_term')}    >終止</th>
          <th className="col-locrpt-term-norm" onClick={e=>toggleSortBy('cnt_normTerm')}>終止(一般)</th>
          <th className="col-locrpt-term-comp" onClick={e=>toggleSortBy('cnt_compTerm')}>終止(公司)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th className="col-locrpt-btn"></th>
          <th className="col-locrpt-loc"> - </th>
          <th className="col-locrpt-loc-name">總數</th>
          <th className="col-locrpt-active"   >{ total.cnt_total }</th>
          <td className="col-locrpt-new-all"  >{ total.cnt_new }</td>
          <td className="col-locrpt-new-fleet">{ total.cnt_newFleet }</td>
          <td className="col-locrpt-new-other">{ total.cnt_newOther }</td>
          <td className="col-locrpt-reu"      >{ total.cnt_reunion }</td>
          <td className="col-locrpt-term-all" >{ total.cnt_term }</td>
          <td className="col-locrpt-term-norm">{ total.cnt_normTerm }</td>
          <td className="col-locrpt-term-comp">{ total.cnt_compTerm }</td>
        </tr>
        { data.map(d =>
          <tr key={d.loc_key}>
            <td className="col-locrpt-btn">
              { (d.cnt_new + d.cnt_reunion + d.cnt_term > 0) &&
                <FontAwesomeIcon icon={faFileAlt} onClick={e=>showDetail(d)} />
              }
            </td>
            <td className="col-locrpt-loc"      >{ d.loc_key }</td>
            <td className="col-locrpt-loc-name" >{ d.loc_name }</td>
            <th className="col-locrpt-active"   >{ d.cnt_total }</th>
            <td className="col-locrpt-new-all"  >{ d.cnt_new }</td>
            <td className="col-locrpt-new-fleet">{ d.cnt_newFleet }</td>
            <td className="col-locrpt-new-other">{ d.cnt_newOther }</td>
            <td className="col-locrpt-reu"      >{ d.cnt_reunion }</td>
            <td className="col-locrpt-term-all" >{ d.cnt_term }</td>
            <td className="col-locrpt-term-norm">{ d.cnt_normTerm }</td>
            <td className="col-locrpt-term-comp">{ d.cnt_compTerm }</td>
          </tr>
        )}
      </tbody>
    </table>
    <ModalScreen show={!!modal} title="詳情" onClose={e=>setModal(null)}>
      { modal }
    </ModalScreen>
  </>);
}


export default LocationReportTable;